import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { VideoErrorComponent } from './video-error.component'
import { OldSvgModule } from 'src/app/libs/_deprecated/svg/old-svg.module'

@NgModule({
  imports: [CommonModule, OldSvgModule],
  declarations: [VideoErrorComponent],
  exports: [VideoErrorComponent]
})
export class VideoErrorModule {}
